import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const EMPTY = { overrides: {}, addedSkillIds: [], runs: [], readUpdateIds: [] }
const MAX_RUNS = 30

const withOverride = (state, id, patch) => ({
  overrides: { ...state.overrides, [id]: { ...state.overrides[id], ...patch } },
})

/**
 * What the user changed about the sample content. Fixtures stay read-only;
 * this holds only deltas, so new fixture copy reaches users who edited nothing.
 */
export const usePulseDemoStore = create(
  persist(
    (set) => ({
      ...EMPTY,
      patchItem: (id, patch) => set((state) => withOverride(state, id, patch)),
      deleteItem: (id) => set((state) => withOverride(state, id, { deleted: true })),
      addSkill: (templateId) =>
        set((state) => ({
          ...withOverride(state, templateId, { deleted: false }),
          addedSkillIds: [templateId, ...state.addedSkillIds.filter((id) => id !== templateId)],
        })),
      recordRun: (run) => set((state) => ({ runs: [run, ...state.runs].slice(0, MAX_RUNS) })),
      markRead: (id) =>
        set((state) => (state.readUpdateIds.includes(id) ? state : { readUpdateIds: [...state.readUpdateIds, id] })),
      reset: () => set(EMPTY),
    }),
    {
      name: 'do-chat-pulse-demo-v1',
      storage: createJSONStorage(() => localStorage),
      version: 1,
      partialize: ({ overrides, addedSkillIds, runs, readUpdateIds }) => ({
        overrides,
        addedSkillIds,
        runs,
        readUpdateIds,
      }),
    },
  ),
)
